/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfWatchlistV1OfacSdnEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_WATCHLIST_V1_OFAC_SDN_EVENT_ENTITY_NAME = 'ixf.watchlist.v1.OfacSdnEvent';
export const ixfWatchlistV1OfacSdnEventEntity = new schema.Entity<IxfWatchlistV1OfacSdnEvent>(IXF_WATCHLIST_V1_OFAC_SDN_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfWatchlistV1OfacSdnEvent) => `${entity.metadata?.eventId}` });

